import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-agent-creation-grid',
  templateUrl: './agent-creation-grid.component.html',
  styleUrls: ['./agent-creation-grid.component.css']
})
export class AgentCreationGridComponent implements OnInit {
title="Pigmy Agents List"
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/masters/agent-creation-grid/agent-creation-grid.component.ts